import { render, staticRenderFns } from "./InputTarif.vue?vue&type=template&id=6ca88a18&scoped=true&"
import script from "./InputTarif.vue?vue&type=script&lang=js&"
export * from "./InputTarif.vue?vue&type=script&lang=js&"
import style0 from "./InputTarif.vue?vue&type=style&index=0&id=6ca88a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca88a18",
  null
  
)

export default component.exports